import type { ManhwaWork } from "@/mocks/works";

const RANK_STYLES: Record<number, string> = {
  1: "bg-primary-500 text-background-50",
  2: "bg-secondary-500 text-background-50",
  3: "bg-accent-500 text-background-50",
};

export default function RankingItem({
  work,
  rank,
  showPop = true,
}: {
  work: ManhwaWork;
  rank: number;
  showPop?: boolean;
}) {
  return (
    <li className="flex items-center gap-3 rounded-xl border border-background-200 bg-background-50 p-3 transition-colors hover:bg-background-100 md:gap-4">
      <span
        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg font-heading text-base font-bold ${
          RANK_STYLES[rank] ?? "bg-background-100 text-foreground-600"
        }`}
      >
        {rank}
      </span>
      <div className="h-16 w-12 shrink-0 overflow-hidden rounded-md md:h-20 md:w-[60px]">
        <img src={work.image} alt={`${work.title} 韩漫封面`} title={`${work.title} 人气韩漫`} className="h-full w-full object-cover object-top" loading="lazy" />
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <h3 className="truncate font-heading text-base font-bold text-foreground-950">{work.title}</h3>
          <span
            className={`shrink-0 rounded-full px-2 py-0.5 text-xs font-medium ${
              work.status === "已完结" ? "bg-secondary-100 text-secondary-900" : "bg-accent-100 text-accent-900"
            }`}
          >
            {work.status}
          </span>
        </div>
        <p className="mt-0.5 hidden truncate text-xs text-foreground-500 sm:block">{work.original}</p>
        <div className="mt-1.5 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
          <span>{work.genres.join(" / ")}</span>
          <span className="hidden text-foreground-300 sm:inline">·</span>
          <span className="hidden sm:inline">{work.episodes}</span>
        </div>
      </div>
      <div className="flex shrink-0 flex-col items-end gap-1.5">
        <span className="flex items-center gap-1 text-sm font-bold text-secondary-600">
          <i className="ri-star-fill text-secondary-500"></i>
          {work.rating.toFixed(1)}
        </span>
        {showPop && (
          <span className="text-xs text-foreground-500">
            <i className="ri-fire-line mr-1 text-primary-500"></i>
            {work.popularity}
          </span>
        )}
      </div>
    </li>
  );
}